import styled from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'

const LoginButton = styled.button`
  background-color: ${({ theme }) => theme.colors.button};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 3px;
  padding: ${rem(15)} ${rem(25)};
  font-size: ${rem(16)};
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.3s;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }

  ${p => p.theme.media.min.md`
    padding: ${rem(15)} ${rem(35)};
  `}
`

export default LoginButton
